import customHeaders, { getSpace } from '../../common/headers';
import { useLocation, useParams } from 'react-router-dom';
import { useDataTable } from '../../common/hooks';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { useState, useEffect, useRef } from 'react';
import {
    DropDownSelector,
    TableBox,
    RangeBox
} from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../store/general';
import './WorkingWithReturns.scss';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { RequestController } from '../../common/filtersFunc';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { useResponseHandler } from '../../common/auth';
import { fetchFilterV3 } from '../../common/filtersFunc';
import { ModalReturns } from './ModalReturns/ModalReturns';
import { periodWeek } from '../../common/constant';
import { msToLocalDate } from '../../common/constant';
import { useSavedFilters } from '../../common/useSavedFilters';

export const options_prop_mp = [
    { label: 'Wildberries', value: 3 },
    { label: 'Yandex', value: 2 },
];

const WorkingWithReturns = () => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
    const { isReady, saveFilters, clearSavedFilters, isSaved, hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'working-with-returns');
    const requestControllerRef = useRef(new RequestController())

    const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();

    const [date, setDate] = useState(periodWeek());
    const [date_from, date_to] = date

    // Modal
    const [isModalReturns, setIsModalReturns] = useState(false)
    const [current, setCurrent] = useState(null)

    // Фильтры
    const filterConfig = [
        { key: 'mp', type: 'multi' },
        { key: 'api', type: 'multi' }
    ];
    const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
    const [isFilterRequest, setIsFilterRequest] = useState(false);

    // Флаг для отслеживания первой инициализации из URL
    const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

    const [apiPage, setApiPage] = useState(1);
    const [apiQuery, setApiQuery] = useState('');
    const [apiData, setApiData] = useState([]);
    const [selectedMarketplace, setSelectedMarketplace] = useState([{ label: 'Все', value: 'all' }]);
    const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);
    const [totalApi, setTotalApi] = useState(0);

    // таблица
    const [isTableRequest, setIsTableRequest] = useState(false);
    const paginatorRef = useRef();
    const [setTable, tableProps, setTableFuncs] = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    );
    const { setLoading, setFetchedData, setHeaders, setSort, setFilters } = setTableFuncs;

    // Инициализация фильтров из URL параметров при первом рендере
    useEffect(() => {
        if (!isReady) return;
        if (!isInitialLoadFromURL) {
            setIsInitialLoadFromURL(true);

            // Обновляем все состояния фильтров
            setTimeout(() => {
                if (urlParams.mp) setSelectedMarketplace(urlParams.mp);
                if (urlParams.api) setSelectedApi(urlParams.api);
                setIsFilterRequest(prev => !prev);
                if (Object.keys(urlParams).length > 0) {
                    setIsTableRequest(prev => !prev);
                }
            }, 10);
        }
    }, [urlParams, isReady]);

    useEffect(() => {
        if (!isReady) return;
        updateURL({
            mp: urlParams?.mp || selectedMarketplace,
            api: urlParams?.api || selectedApi,
        })
    }, [isReady]);

    // Таблицы
    const fetchTableData = (params, abortController = new AbortController()) => {

        setLoading(true)
        let sort;
        let filters;

        if (params) {
            [sort, filters] = params;
        }

        let url = `https://apps2.ecomru.ru:4655/v1/returns/table${sort?.length > 0
            ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
            : ''}`;

        const body = JSON.stringify({
            mp_id_list: getValueMultiFilter(selectedMarketplace),
            api_id_list: getValueMultiFilter(selectedApi),
            date_from: msToLocalDate(date_from),
            date_to: msToLocalDate(date_to),
            filters,
            page: paginatorRef.current.page,
            limit: paginatorRef.current.limit,
        });

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((table) => setTable(table))
            .catch(handleRequestError)
            .finally(() => {
                if (abortController.signal.aborted) return
                setLoading(false)
            })
    };

    const filtersApi = () => {
        const controller = requestControllerRef.current.createController('api');

        fetchFilterV3({
            selectedSpace: selectedSpace?.value,
            selectedMP: selectedMarketplace,
            page: apiPage,
            set: setApiData,
            searchParam: apiQuery,
            controller,
            setTotal: setTotalApi,
            filter: 'mp_product_api_ids',
            excludeMP: true
        })?.finally(() => {
            requestControllerRef.current.removeController('api');
        })
    };

    const onAction = (e) => {
        const return_id = e?.['return_id']
        const mp_id = e?.['mp_id']
        const api_id = e?.['api_id']
        setCurrent({ return_id, mp_id, api_id })
        setIsModalReturns(true)
    }

    useEffect(() => {
        if (!isInitialLoadFromURL) return;
        filtersApi()
    }, [isFilterRequest, apiPage, apiQuery]);

    useEffect(() => {
        if (!isModalReturns) {
            if (!isReady) return;
            const abortController = new AbortController();
            fetchTableData([], abortController);
            return () => abortController.abort();
        }
    }, [isTableRequest, date, isModalReturns]);


    return (
        <>
            {isModalReturns && <ModalReturns
                current={current}
                setIsModal={setIsModalReturns}
            />}

            <div className="working-with-returns">
                <TitlePage
                    title='Работа с возвратами'
                />

                <div className="working-with-returns__filters">
                    <FilterContainer
                        loading={isSaved}
                        saveFilters={saveFilters}
                        clearSavedFilters={clearSavedFilters}
                        hasSavedFilters={hasSavedFilters}
                        onReset={(e) => {
                            setSelectedMarketplace([])
                            setSelectedApi([]);
                            updateURL({
                                mp: null,
                                api: null,
                            });
                            setIsFilterRequest(!isFilterRequest);
                            setIsTableRequest(!isTableRequest)
                        }}
                    >
                        <DropDownSelector
                            options_prop={options_prop_mp}
                            state={selectedMarketplace}
                            setState={(e) => setSelectedMarketplace(e)}
                            placeholder="Площадка"
                            total={options_prop_mp?.length}
                            multi
                            onBlur={e => {
                                updateURL({ mp: selectedMarketplace });
                                filtersApi()
                                setIsTableRequest(!isTableRequest)
                            }}
                        />

                        <DropDownSelector
                            options_prop={apiData}
                            state={selectedApi}
                            setState={setSelectedApi}
                            placeholder="Магазин"
                            total={totalApi}
                            multi
                            fetchCallback={setApiPage}
                            setInputChange={setApiQuery}
                            onBlur={e => {
                                updateURL({ api: selectedApi });
                                setIsTableRequest(!isTableRequest)
                            }}
                        />
                    </FilterContainer>

                    <RangeBox
                        date={date}
                        setDate={(e) => {
                            const [newDateFrom, newDateTo] = e;
                            updateURL({
                                date_from: newDateFrom,
                                date_to: newDateTo
                            });
                            setDate(e)
                        }}
                    />
                </div>

                <TableBox
                    {...tableProps}
                    ref={paginatorRef}
                    paginator={true}
                    fetchCallback={fetchTableData}
                    onAction={onAction}
                />
            </div>
        </>
    );
};

export { WorkingWithReturns };
